import { useEffect, useState } from "react";
import Spinner from "@/components/common/spinner/Spinner";
import {
    getCurrentLegalDocument,
    type legalDocument,
} from "@/api/complianceService";
import styles from "./LegalDocumentPage.module.css";

interface props {
    docType: string;
}

/** Página pública que muestra el documento legal vigente (política o aviso). */
const LegalDocumentPage: React.FC<props> = ({ docType }) => {
    const [doc, setDoc] = useState<legalDocument | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        document.body.classList.add("solid-public-bg");
        return () => document.body.classList.remove("solid-public-bg");
    }, []);

    useEffect(() => {
        let active = true;
        setLoading(true);
        getCurrentLegalDocument(docType)
            .then((d) => active && setDoc(d))
            .catch(
                () => active && setError("No hay un documento vigente publicado."),
            )
            .finally(() => active && setLoading(false));
        return () => {
            active = false;
        };
    }, [docType]);

    if (loading) return <Spinner text="Cargando documento..." />;

    return (
        <main className={styles["doc-page"]}>
            {error ? (
                <p className={styles["doc-error"]}>{error}</p>
            ) : (
                <article className={styles["doc-article"]}>
                    <h1 className={styles["doc-title"]}>{doc?.title}</h1>
                    <p className={styles["doc-meta"]}>
                        Versión {doc?.version} — vigente desde {doc?.effective_date}
                    </p>
                    <div className={styles["doc-body"]}>{doc?.content}</div>
                </article>
            )}
        </main>
    );
};

export default LegalDocumentPage;
